import { genTestUserSig2 } from '../../public/debug/GenerateTestUserSig'
const SDKAPPID = genTestUserSig2('').sdkAppID;
export default {
  SDKAppID: SDKAPPID,
  CallTimeout: 60
}
